import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/app/layouts/account.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/app/layouts/login.vue").then(m => m.default || m)),
  mobile: defineAsyncComponent(() => import("/app/layouts/mobile.vue").then(m => m.default || m)),
  panel: defineAsyncComponent(() => import("/app/layouts/panel.vue").then(m => m.default || m)),
  test: defineAsyncComponent(() => import("/app/layouts/test.vue").then(m => m.default || m))
}